import React, {useState} from "react";
import "./style.scss";
import Login from "./Login";
import Register from "./Register";
import ChangePassword from "./ChangePassword";
import {useTranslation} from "react-i18next";
import DBModal from "../DBModal";
import RegisterCompany from "./RegisterCompany";

export default function AuthModal() {
  const {t} = useTranslation();

  const [activeTab, setActiveTab] = useState(0);

  // Always default to username/password login (superuser/admin cannot use OTP-only flow).
  const [mode, setMode] = useState(1);
  const [phone, setPhone] = useState("");

  const modeHandle = (e) => {
    setMode(e);
  };

  const tabHandler = (e) => {
    if (e == 0 && window.innerWidth < 1024) {
      setMode(2);
    } else {
      setMode(1);
    }
    setActiveTab(e);
  };

  // useEffect(() => {
  //     setMode(1);
  // }, [activeTab]);

  return (
    <DBModal
      color="#7c4dff"
      blurred={true}
      minWidth={768}
      show={true}
      className="auth-modal"
    >
      <DBModal.Tab
        tabs={[
          t("LogInWindow.Tab"),
          t("SignUp.Tab"),
          t("Company.SignUp.Tab"),
          t("ChangePassword.Tab"),
        ]}
        selected={activeTab}
        onChange={tabHandler}
        color="white"
      />
      <DBModal.Content>
        {activeTab == 0 && (
          <Login
            key={activeTab + 1}
            mode={mode}
            setMode={modeHandle}
            phoneInit={phone}
            setActiveTab={setActiveTab}
          />
        )}
        {activeTab == 1 && (
          <Register
            key={activeTab + 2}
            setPhoneInit={setPhone}
            setMode={modeHandle}
            setActiveTab={(e) => setActiveTab(e)}
          />
        )}
        {activeTab == 2 && (
          <RegisterCompany
            key={activeTab + 2}
            setPhoneInit={setPhone}
            setMode={modeHandle}
            setActiveTab={(e) => setActiveTab(e)}
          />
        )}
        {activeTab == 3 && (
          <ChangePassword
            key={activeTab + 3}
            mode={mode}
            setMode={modeHandle}
            phoneInit={phone}
            setActiveTab={setActiveTab}
          />
        )}
      </DBModal.Content>
    </DBModal>
    // <Modal show={true} id="auth-mo" className="auth_modal" backdropClassName="auto-modal-backdrop">
    //   <ModalBody>
    //     <div className="auth-modal-container">
    //       <div className="tab-section">
    //         <Tabs
    //           activeKey={activeTab}
    //           transition={false}
    //           className="panel_tab"
    //           onSelect={(e) => setActiveTab(e)}
    //         >
    //           <Tab eventKey="1" className="panel_tab_item" title={t('LogInWindow.Tab')}>
    //             {
    //               activeTab == 1 && (<Login key={activeTab + 1} mode={mode} setMode={modeHandle} phoneInit={phone}
    //                                         setActiveTab={setActiveTab}/>)
    //             }
    //           </Tab>
    //           <Tab
    //             eventKey="2"
    //             className="panel_tab_item"
    //             title={t('SignUp.Tab')}
    //           >
    //             {
    //               activeTab == 2 && (<Register key={activeTab + 2} setPhoneInit={setPhone} setMode={modeHandle}
    //                                            setActiveTab={(e) => setActiveTab(e)}/>)
    //             }
    //           </Tab>
    //           <Tab
    //             eventKey="3"
    //             className="panel_tab_item"
    //             title={t('ChangePassword.Tab')}
    //           >
    //             {
    //               activeTab == 3 && (
    //                 <ChangePassword key={activeTab + 3} mode={mode} setMode={modeHandle} phoneInit={phone}
    //                                 setActiveTab={setActiveTab}/>)
    //             }
    //           </Tab>
    //         </Tabs>
    //       </div>
    //     </div>
    //   </ModalBody>
    // </Modal>
  );
}
